import React, { useMemo, useRef } from "react";
import CardChart from "../../components/Cards/CardChart";
import Table from "../../layouts/Table";
import ProductTable from "../../components/Table/Product/ProductTable";
import { ItemProps, useFetch, useItems } from "../../hooks/useFetch";
import { IProduct } from "../../types";
import { ILog } from "../../types/logType";

const ProductPage = () => {
	const item = useRef([]);

	const [clicks] = useFetch(
		useMemo<Partial<ILog>>(() => {
			return { action: "page" };
		}, []),
		"count"
	);

	const [search] = useFetch(
		useMemo<Partial<ILog>>(() => {
			return { action: "search" };
		}, []),
		"group"
	);

	const [category] = useFetch(
		useMemo<Partial<ILog>>(() => {
			return { action: "category" };
		}, []),
		"group"
	);

	const [interaction] = useFetch(
		useMemo<Partial<ILog>>(() => {
			return { category: "product" };
		}, []),
		"count"
	);

	const opts = useMemo<Partial<ItemProps>>(() => {
		return { type: "product", all: true };
	}, []);
	const [newProducts, , loading] = useItems<IProduct>(item.current, opts);

	return (
		<div className="grid gap-y-6">
			{" "}
			<div className="grid grid-cols-12 gap-x-6">
				{" "}
				<CardChart
					type="line"
					title="Product page view"
					className="col-span-8"
					theme="dark"
					data={clicks}
				/>
				<CardChart
					type="doughnut"
					title="Most searched item"
					className="col-span-4"
					data={search}
				/>
				{/* <CardChart
          type="doughnut"
          title="First clicked item"
          className="col-span-3"
        /> */}
			</div>
			<div className="grid grid-cols-12 gap-x-6">
				<CardChart
					type="pie"
					subtitle="Percentage"
					title="Click by Category"
					className="col-span-4"
					data={category}
				/>
				<CardChart
					type="bar"
					title="Product Interaction"
					className="col-span-8"
					data={interaction}
				/>
			</div>
			<Table
				title="New Product"
				icon="fas fa-boxes"
				theme={"light"}
				iconColor="text-orange-500"
				loading={loading}
				to="/dashboard/product/all"
			>
				{" "}
				<ProductTable data={newProducts.slice(0, 5)} />
			</Table>
		</div>
	);
};

export default ProductPage;
